import { Injectable } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

@Injectable()
export class YearPickerValueAccessor implements ControlValueAccessor {
  private onChange: any = () => {};
  private onTouched: any = () => {};
  private value: any;

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implementa esto si necesitas manejar el estado disabled
  }

  setValue(value: any) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  getValue() {
    return this.value;
  }
}